<template>
    <div>
        <b-table
            :empty-text="$t('there_are_no_records')"
            bordered
            striped
            responsive
            :items="purchaseOrderForms"
            :fields="fields"
            show-empty
            class="mb-5 table-dropdown no-scrollbar border rounded"
        >
            <template #cell(actions)="data">
                <b-dropdown
                    no-caret
                    right
                    variant="link"
                    toggle-class="p-0 text-muted"
                >
                    <template #button-content>
                        <i class="ri-more-fill"></i>
                    </template>

                    <b-dropdown-item @click="$router.push('/purchase-order/' + data.item.id)">
                        <i class="ri-eye-line mr-2 text-primary"></i>{{ $t('detail') }}
                    </b-dropdown-item>
                </b-dropdown>
            </template>

            <!-- Requester -->
            <template #cell(requester)="data">
                {{ data.item.name }} {{ data.item.surname }}
            </template>

            <!-- Active Step -->
            <template #cell(active_step)="data">
                {{ data.item.active_step ? data.item.active_step.name : '-' }}
            </template>
        </b-table>
    </div>
</template>

<script>
import PurchaseOrderFormService from "@/services/PurchaseOrderFormService";
import qs from "qs";

export default {
    name: "PurchaseOrderForm",
    props: {
        filter: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            purchaseOrderForms: [],
            fields: [
                { key: "actions", label: "", tdClass: "text-center" },
                { key: "requester", label: this.toUpperCase("requester") },
                { key: "employee_id", label: this.toUpperCase("employee_id") },
                { key: "budgetary_department_name", label: this.toUpperCase("budgetary_department") },
                { key: "active_step", label: this.toUpperCase("active_step") },
                { key: 'status_name', label: this.toUpperCase("status") },
                { key: "last_approve_date", label: this.toUpperCase("last_approve_date") },
            ],
            itemFields: [
                { key: "item_name", label: this.toUpperCase("item_name") },
                { key: "price_per_unit", label: this.toUpperCase("price_per_unit"), thClass: "text-right", tdClass: "text-right" },
                { key: "quantity", label: this.toUpperCase("quantity"), thClass: "text-center", tdClass: "text-center",},
            ],
        };
    },
    created() {
        this.getData();
    },
    methods: {
        async getData() {
            const config = {
                ...this.filter,
                paramsSerializer: (params) => qs.stringify(params, { encode: false }),
            };
            try {
                const response = await PurchaseOrderFormService.getAll(config);
                this.purchaseOrderForms = response.data.data;
            } catch (e) {
                this.showErrors(e);
            }
        },

    },
};
</script>
